import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  ContactoAtencionContent,
  ContactoAtencionKind,
  getContactoAtencionContent,
} from '../../data/contacto-atencion.content';

export type ContactoAtencionInfoVariant = 'page' | 'modal';

@Component({
  selector: 'app-contacto-atencion-info',
  templateUrl: './contacto-atencion-info.component.html',
  styleUrls: ['./contacto-atencion-info.component.scss'],
  standalone: true,
})
export class ContactoAtencionInfoComponent implements OnChanges {
  @Input({ required: true }) kind!: ContactoAtencionKind;
  /** `page` = deep-link; `modal` = footer Home V2. */
  @Input() variant: ContactoAtencionInfoVariant = 'page';
  /** Si es false, el título lo controla el contenedor (p. ej. header del modal). */
  @Input() showTitle = true;

  content: ContactoAtencionContent | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['kind'] && this.kind) {
      this.content = getContactoAtencionContent(this.kind);
    }
  }
}
